<template>
	<div class>
		<!-- Modal Component -->
		<ModalBox v-model="legacyModalVisible" size="lg" hide-close header-class="!hidden" wrapper-classes="lg:h-auto lg:max-h-none px-3">

			<template #modal-header>
				<div class="w-full flex flex-wrap">
					<div class="w-full">
						<div class="stream-type-info">
							<p class="text-s-m text-dark-8 mt-2">Select the file you'd like to upload.</p>
							<div v-if="!selectedStream._id">
								<h4 class="text-s-xxxl hidden md:block text-500">Add recorded videos</h4>
								<div class="relative search-form search-vod ml-auto mb-4">
									<IconBase class="absolute left-2 top-1/2 -translate-y-1/2 text-dark-8">
										<IconSearch />
									</IconBase>
									<FormInput ref="searchWidgetInputElement" placeholder="Search for files" class="search-form__field"
										v-model="searchString"
										customClasses="!border-0 !bg-transparent !pl-10 !pr-8" />
								<FormButton type="light" :isIcon="true" size="md" class="search-clear -ml-5">
									<IconBase class="text-white" :width="16" :height="17" width-view-box="16" height-view-box="17"><IconCloseCircle /></IconBase>
								</FormButton>
									<drop-down-menu v-if="!hideFilters" ref="filter-vod" listClasses="dropdown-menu_md dropdown-menu_tag-list" customClasses=""
										type="surface-4" size="md" class="md:ml-2 mb-4 md:mb-0 tag-filter">
<template #toggle-button>
											<div class="flex justify-between items-center w-full">
												<div class="text-dark-8 mr-2">{{ streamType }}</div>
											</div>
										</template>

<template #menu-items>
<drop-down-menu-item @click="streamType = 'All'" customClasses="flex justify-between items-center tag-item">
											<span class="">All</span>
										</drop-down-menu-item>
										<drop-down-menu-item @click="streamType = 'Live-to-VOD'" customClasses="flex justify-between items-center tag-item">
											<span class="">Live-to-VOD</span>
										</drop-down-menu-item>
										<drop-down-menu-item @click="streamType = 'Normal VOD Folders'" customClasses="flex justify-between items-center tag-item">
											<span class="">Normal VOD Folders</span>
										</drop-down-menu-item>
</template>
</drop-down-menu>
								</div>
							</div>
							<div v-else class="flex mr-1 items-start">
								<FormButton type="light" :isIcon="true" size="sm" @click="navigateManage()" class="text-dark-7 px-2">
									<IconBase class="text-[#FAFAFB]" :width="8" :height="14" width-view-box="8" height-view-box="14" fill="none"><IconChevronLeftThin /></IconBase>
								</FormButton>
								<span class="items-start mt-1">
									<h4 class="text-s-xl hidden md:block text-500">{{ selectedStream.name }}</h4>
								</span>
							</div>
						</div>
					</div>
				</div>
			</template>
			<div class="modal-container">
				<!-- Summary table -->
				<DataTable v-if="isLoaded && filterStreams.length && !selectedStream._id" :items="paginatedFolders" :fields="fields"
					table-class="main-table main-table_bordered-3" thead-class="text-dark-6">
					<template #cell(name)="row">
						<div @click="navigateManage(row.item)" class="flex items-center cursor-pointer">
							<IconBase v-if="!row.item.isFile" class="mr-2 text-dark-8" :width="24" :height="24" width-view-box="24" height-view-box="24"><IconFolderRounded /></IconBase>
							<div class="text-nowrap text-dark-9 text-s-m">
								<Badge v-if="row.item.liveParent" type="main"
									class="badge_beta static mr-2">Live-to-VOD</Badge>
								{{ toShortString(row.item.name, 25) }}
							</div>
						</div>
					</template>
					<template #cell(files)="row">
						<div @click="navigateManage(row.item)" class="text-nowrap text-dark-9 cursor-pointer">
							{{ row.item.totalFiles }}
						</div>
					</template>
					<template #cell(date)="row">
						<div @click="navigateManage(row.item)" class="text-nowrap text-dark-9 cursor-pointer">
							{{ dateFormated(row.item.creationTime, "hh:mm DD-MM-YYYY") }}
						</div>
					</template>
				</DataTable>

				<!-- Folder pagination -->
				<div v-if="isLoaded && filterStreams.length && !selectedStream._id && totalFolderPages > 1"
					class="flex justify-center items-center gap-1 mt-3">
					<FormPagination
						v-model="folderCurrentPage"
						:total-rows="filterStreams.length"
						:per-page="foldersPerPage"
						size="sm"
						class="mb-0"
						first-number
						last-number
					/>
				</div>

				<!-- Details table-->
				<DataTable v-else-if="isPlaylistLoaded" :items="selectedStream.playlist" :fields="fieldDetails"
					table-class="main-table main-table_bordered-3  text-s-m" thead-class="text-dark-6">
					<template #cell(name)="row">
						<div class="flex items-center cursor-pointer">
							<div class="flex text-nowrap text-dark-9 items-center">
								<FormCheckbox class="mr-2" @change="toggleVideo(row.item)" v-model="row.item.selected"
									:disabled="row.item.invalid" :inputValue="true" name="selected-live-to-vod" />
								{{ toShortString(row.item.fileName, 25) }}
							</div>
						</div>
					</template>
					<template #cell(size)="row">
						<div class="text-nowrap text-dark-9 cursor-pointer">
							{{ getBytes(row.item.bytes) }}
							<Tooltip :content="row.item.errorMessage"><IconBase class="mb-1 text-[#E25858]" v-if="row.item.invalid"
								:id="`${row.item.from}-${row.item.duration}`" :width="14" :height="15" width-view-box="14" height-view-box="15"><IconExclamationCircle /></IconBase></Tooltip>
						</div>
					</template>
					<template #cell(duration)="row">
						<div class="text-nowrap text-dark-9 cursor-pointer">
							{{ formatDurations(row.item?.mediaInfo?.duration) }}
						</div>
					</template>
					<template #cell(date)="row">
						<div class="text-nowrap text-dark-9 cursor-pointer">
							{{ dateFormated(row.item.creationTime, "hh:mm DD-MM-YYYY") }}
						</div>
					</template>
				</DataTable>
			</div>
			<template #modal-footer>
				<div class="flex justify-between items-center w-full">
					<span class="text-dark-8 text-s-s">{{ totalFilesSelected }} file{{ totalFilesSelected !== 1 ? 's' : '' }} selected</span>
					<div class="flex items-center gap-2">
						<FormButton type="secondary" size="md" @click="hideLegacyModal()">
							Cancel
						</FormButton>
						<FormButton v-if="isLoaded && !isLoading" type="main" size="md" @click="onConfirm"
							:disabled="totalFilesSelected + videoFiles.length > totalFilesPerStream || totalFilesSelected === 0">
							Add video
						</FormButton>
						<FormButton v-else type="main" size="md"
							disabled>
							<Spinner text="Adding..." classes="text-dark-8" spinner-color="var(--c-dark-8)" spinner-size="15px" />
						</FormButton>
					</div>
				</div>
			</template>
		
</ModalBox>
	</div>
</template>

<script>
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import { APP_EVENTS, appEventBus } from '@/Utils/appEventBus'
import Tooltip from '@/components/Atoms/Tooltip.vue'
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { Duration } from "luxon";
import ClipLoader from "@/components/ui/ClipLoader.vue";
import StreamService from '@/services/StreamService';
import MetricsService from '@/services/MetricsService'
import IconBase from '@/components/icon/IconBase.vue';
import IconLivestream from '@/components/icon/IconLivestream.vue';
import IconMultistream from '@/components/icon/IconMultistream.vue';
import IconIpcam from '@/components/icon/IconIpcam.vue';
import IconSchedulestream from '@/components/icon/IconSchedulestream.vue';
import IconVodChannel from '@/components/icon/IconVodChannel.vue';
import UserService from '../../services/UserService';
import Spinner from "@/components/ui/Spinner.vue"
import { shortString, date } from '@/filtersNew'
import FormButton from '@/components/Atoms/FormButton.vue';
import FormInput from '@/components/Atoms/FormInput.vue';
import FormCheckbox from '@/components/Atoms/FormCheckbox.vue';
import Alert from '@/components/Atoms/Alert.vue';
import Badge from '@/components/Badge.vue';
import DropDownMenu from '@/components/Atoms/DropDownMenu.vue'
import DropDownMenuItem from '@/components/Atoms/DropDownMenuItem.vue'
import IconSearch from '@/components/icon/IconSearch.vue';
import IconCloseCircle from '@/components/icon/IconCloseCircle.vue';
import IconChevronLeftThin from '@/components/icon/IconChevronLeftThin.vue';
import IconFolderRounded from '@/components/icon/IconFolderRounded.vue';
import IconExclamationCircle from '@/components/icon/IconExclamationCircle.vue';
import DataTable from '@/components/Atoms/DataTable.vue';
import FormPagination from '@/components/Atoms/FormPagination.vue';
import { track, EVENTS } from '@/lib/tracking';

export default {
	name: 'SelectLiveToVodModal',
	mixins: [legacyModalBridgeMixin],
	computed: {
		legacyModalId() { return 'modal-select-live-to-vod' },
	},
	components: {
		ModalBox,
		Tooltip,
    DropDownMenu,
    DropDownMenuItem,
		Alert,
		FormButton,
		FormInput,
		FormCheckbox,
		ClipLoader,
		IconBase,
		IconSearch,
		IconCloseCircle,
		IconChevronLeftThin,
		IconFolderRounded,
		IconExclamationCircle,
		IconLivestream,
		IconMultistream,
		IconIpcam,
		IconSchedulestream,
		IconVodChannel,
		Spinner,
		Badge,
		DataTable,
		FormPagination,
	},
	data() {
		return {
			selectedStream: {},
			streams: [],
			videoFilename: null,
			scheduledStorageLimit: {},
			activeScheduledSub: {},
			totalFilesSelected: 0,
			isLoaded: false,
			isLoading: false,
			isPlaylistLoaded: false,
			exceededFileQuota: false,
			searchString: '',
			streamType: 'All',
			hideFilters: false,
			folderCurrentPage: 1,
			foldersPerPage: 10,
		};
	},
	props: {
		video: {
			type: Object,
		},
		stream: {
			type: Object,
		},
		totalFilesPerStream: Number,
		videoFiles: Array
	},
	computed: {
		...mapGetters({
			allStreams: 'Streams/streams',
		}),
		fields() {
			const allFields = [
				{ key: "name", label: "Name", sortable: true, sortDirection: "desc", class: 'text-500 text-s-s text-dark-6 pl-0' },
				{ key: "files", label: "Files", sortable: true, sortDirection: "desc", class: 'text-500 text-s-s text-dark-6' },
				{ key: "date", label: "Date", sortable: true, sortDirection: "desc", class: 'text-500 text-s-s text-dark-6' },
			];

			return allFields;
		},
		fieldDetails() {
			const allFields = [
				{ key: "name", label: "Name", sortable: true, sortDirection: "desc", class: 'pl-0' },

				{ key: "size", label: "File Size", sortable: true, sortDirection: "desc" },
				{ key: "duration", label: "Duration", sortable: true, sortDirection: "desc" },
				{ key: "date", label: "Date", sortable: true, sortDirection: "desc" },
			];

			return allFields;
		},
		preRecordedName() {
			return this.filename + '.mp4'
		},
		filename() {
			this.videoFilename = !this.videoFilename ? this.video.name : this.videoFilename
			return this.videoFilename
		},
		isScheduledTrialSub() {
			// Check Pre-recorded Stream 500MB - 7 Days Trial sub
			const subscriptions = this.$store.state.User.subscriptions;
			return subscriptions.some((sub) => sub.package._id === '5cd5485126fd039846a3255f')
		},
		maxVideoFileSize() {
			let maxSize = null;
			const subscriptions = this.$store.state.User.subscriptions;
			const activeScheduledSubs = _.filter(subscriptions, (sub) => sub.category === 'scheduled' && sub.enabled === true)

			activeScheduledSubs.forEach(sub => {
				try {
					let overrideSchedulerMaxVideoSize = parseFloat(sub.package.definition.schedulerMaxVideoSize);
					if (sub.definitionOverride && sub.definitionOverride.schedulerMaxVideoSize) {
						overrideSchedulerMaxVideoSize = parseFloat(sub.definitionOverride.schedulerMaxVideoSize)
					}
					if (maxSize) {
						const tmpMaxSize = overrideSchedulerMaxVideoSize;
						if (tmpMaxSize > maxSize) {
							maxSize = tmpMaxSize;
							this.activeScheduledSub = sub
						}
					} else {
						maxSize = overrideSchedulerMaxVideoSize;
						this.activeScheduledSub = sub
					}
				} catch (error) {
					console.error(error);
				}
			})

			if (this.scheduledStorageLimit?.unitsLeft > 0 && this.scheduledStorageLimit.unitsLeft < maxSize) {
				maxSize = parseFloat(this.scheduledStorageLimit.unitsLeft / (1000 ** 3)).toFixed(1)
			}
			if (this.scheduledStorageLimit?.unitsLeft <= 0) {
				maxSize = 0
			}
			return maxSize;
		},
		filterStreams() {
			const filteredStreams = _.orderBy(this.streams, ['creationTime'], ['desc']).filter((stream) => {
				if (stream.type !== 'vod') return false;
				return true
			});
			if (this.streamType === 'All') {
				return filteredStreams.filter(stream => stream.name.includes(this.searchString))
			} else if (this.streamType === 'Live-to-VOD') {
				return filteredStreams.filter(stream => stream.liveParent).filter(stream => stream.name.includes(this.searchString))
			} else if (this.streamType === 'Normal VOD Folders') {
				return filteredStreams.filter(stream => !stream.liveParent).filter(stream => stream.name.includes(this.searchString))
			}
		},
		paginatedFolders() {
			const start = (this.folderCurrentPage - 1) * this.foldersPerPage;
			return this.filterStreams.slice(start, start + this.foldersPerPage);
		},
		totalFolderPages() {
			return Math.ceil(this.filterStreams.length / this.foldersPerPage);
		},
		videoSelected() {
			
				let unitsLeft = this.scheduledStorageLimit.unitsLeft
				this.selectedStream?.playlist?.forEach((item) => {
					if (item.selected) unitsLeft -= item.bytes
				})
				let selectedItems = this.selectedStream?.playlist?.map((item) => {
					if (!item.selected) {
						item.invalid = !(item.bytes <= parseFloat(this.maxVideoFileSize) * (1000 ** 3) && item.bytes <= unitsLeft && unitsLeft > 0)
						if (item.invalid) {
							if (item.bytes > parseFloat(this.maxVideoFileSize) * (1000 ** 3)) {
								item.errorMessage = 'Only file under ' + this.maxVideoFileSize + 'GB are allowed.'
							}
							if (item.bytes > unitsLeft || unitsLeft <= 0) {
								item.errorMessage = 'Your total storage limit has been exceeded. Please upgrade your subscription or delete some files to continue.'
							}
						}
					}
					return item
				})
				const videos = selectedItems?.filter(item => item.selected) || []
				return videos
			
		},
		activeTeam() {
			return this.$store.state.User.activatedTeam;
		}
	},
	async mounted() {
		this._onSelectLiveToVodStreamType = (type) => {
			this.streamType = type
			if (type !== 'All') {
				this.hideFilters = true;
			}
		}
		appEventBus.on(APP_EVENTS.SELECT_LIVE_TO_VOD_STREAM_TYPE, this._onSelectLiveToVodStreamType)
		while (!this.$store.state.User) {
			// Waiting
		}
		const subscriptions = this.$store.state.User.subscriptions;
		const activeScheduledSubs = _.filter(subscriptions, (sub) => sub.category === 'scheduled' && sub.enabled === true)

		let maxSize
		activeScheduledSubs.forEach(sub => {
			try {
				if (maxSize) {
					const tmpMaxSize = parseFloat(sub.package.definition.schedulerMaxVideoSize);
					if (tmpMaxSize > maxSize) {
						maxSize = tmpMaxSize;
						this.activeScheduledSub = sub
					}
				} else {
					maxSize = parseFloat(sub.package.definition.schedulerMaxVideoSize);
					this.activeScheduledSub = sub
				}
			} catch (error) {
				console.error(error);
			}
		})
		const res = await MetricsService.getSubscriptionStorage(UserService.getUserId(this.activeTeam), this.activeScheduledSub?.package?._id)
		this.scheduledStorageLimit = res ? res : {}
		this.streams = this.allStreams;
		this.isLoaded = true
	},
	beforeUnmount() {
		if (this._onSelectLiveToVodStreamType) {
			appEventBus.off(APP_EVENTS.SELECT_LIVE_TO_VOD_STREAM_TYPE, this._onSelectLiveToVodStreamType);
		}
	},
	methods: {
		async onLegacyModalShow() {
			this.selectedStream = {}
			const res = await MetricsService.getSubscriptionStorage(
				UserService.getUserId(this.activeTeam),
				this.activeScheduledSub?.package?._id
			)
			this.scheduledStorageLimit = res ? res : {}
		},
		// was @hide="reset" on the old b-modal
		onLegacyModalHide() {
			this.reset();
		},
		videoValidate(video) {
			return (video.bytes <= parseFloat(this.maxVideoFileSize) * (1000 ** 3) && video.bytes <= this.scheduledStorageLimit.unitsLeft && this.scheduledStorageLimit.unitsLeft > 0)
		},
		onDismiss() {
			this.hideLegacyModal();
			setTimeout(() => {
				this.hideFilters = false;
			}, 800);
		},
		async onConfirm() {
			try {
				this.isLoading = true
				const streamObj = this.stream
				const addedCount = this.videoSelected.length
				this.videoSelected.forEach(async (video) => {
					// Create playlist data
					let videoId
					let importedVideoId
					if (video.liveToVod) {
						const videoUrl = video.downloadUrl
						const fileName = videoUrl.substring(videoUrl.indexOf(streamObj.user))
						let prefix
						if (video.archive) {
							prefix = video.archive.abr ? 'edge-en' : 'edge'
						} else {
							prefix = video.abr ? 'edge-en' : 'edge'
						}
						videoId = `episodes/${prefix}/${fileName}`
					} else {
						importedVideoId = video.srcHls.substring(video.srcHls.indexOf('videos/'), video.srcHls.indexOf('/index.m3u8'))
						videoId = video.id
					}

					const payload = {
						id: videoId,
						fileName: video.fileName + '.mp4',
						type: video.liveToVod ? 'live-to-vod' : 'imported',
						bytes: video.bytes,
						mediaInfo: {
							codecs: [{ type: 'video', codec: 'AVC' }, { type: "audio", codec: "AAC" }],
							duration: video.mediaInfo.duration,
							durationMins: video.mediaInfo.durationMins
						}
					}
					if (payload.type === 'imported') payload.importedVideoId = importedVideoId
					const scheduledConfig = await StreamService.saveStreamPlaylistVideo(streamObj._id, payload)
					await this.$store.dispatch('Streams/getStreams');
				})
				track(EVENTS.VOD_ADDED_TO_STREAM, { count: addedCount, streamId: streamObj._id })
			} catch (err) {
				this.$notify({ group: 'error', title: err.error, text: err.message });
				console.log(err);
			}
			
			setTimeout(() => {
				this.onDismiss();
				this.$emit('updated');
				this.isLoading = false
			}, 2000);
		},
		reset() {
			this.totalFilesSelected = 0
			this.searchString = ''
			setTimeout(() => {
				this.streamType = 'All'
				this.hideFilters = false;
			}, 800);
		},
		navigateManage(stream) {
			if (!stream) {
				this.selectedStream = {}
				this.isPlaylistLoaded = false
			} else {
				this.selectedStream =_.cloneDeep(stream)
				StreamService.getStreamPlaylist(this.selectedStream._id).then(res => {
					this.selectedStream.playlist = res
					this.selectedStream.playlist = this.selectedStream.playlist.map(item => {
						item.liveToVod = this.selectedStream.liveParent ? true : false
						item.selected = false
						item.invalid = !this.videoValidate(item)
						if (item.invalid) item.errorMessage = this.getErrorMessage(item)
						return item
					})
					this.isPlaylistLoaded = true
				})
			}
		},
		getBytes(size) {
			if (size > 0) {
				let totalBytes = size;
				var i = Math.floor(Math.log(totalBytes) / Math.log(1000)),
					sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
				return (totalBytes / Math.pow(1000, i)).toFixed(2) * 1 + " " + sizes[i];
			} else {
				return 0;
			}
		},
		getErrorMessage(video) {
			let errorMessage = ''

			if (video.bytes > parseFloat(this.maxVideoFileSize) * (1000 ** 3)) {
				errorMessage = 'Only file under ' + this.maxVideoFileSize + 'GB are allowed.'
			}
			if (video.bytes > this.scheduledStorageLimit.unitsLeft || this.scheduledStorageLimit.unitsLeft <= 0) {
				errorMessage = 'Your total storage limit has been exceeded. Please upgrade your subscription or delete some files to continue.'
			}
			return errorMessage
		},
		formatDurations(durationSeconds) {
			if (!durationSeconds) return "-";
			let formatStr = "s's'";
			if (durationSeconds >= 60) formatStr = "m'm' s's'";
			if (durationSeconds >= 3600) formatStr = "h'h' " + formatStr;
			if (durationSeconds >= 1440 * 60) formatStr = "d'd' " + formatStr;
			return Duration.fromObject({ seconds: durationSeconds }).toFormat(
				formatStr
			);
		},
		toggleVideo(item) {
			if (item.selected) {
				this.totalFilesSelected = this.totalFilesSelected + 1
			} else {
				this.totalFilesSelected = this.totalFilesSelected - 1
			}
		},
		toShortString(value, number) {
			return shortString(value, number)
		},
		dateFormated(item, format) {
			return date(item, format)
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-form__field {
	min-width: 200px
}
</style>
